import { CurrencyExchange } from "@mui/icons-material";
import { filterSousMenu } from "menu-items";
// import { filterSousMenu } from "menu-items";
import { UserModule } from "types";
import { LINKS } from "utils/constant";

const sousmenus = [
  {
    id: "collectes",
    title: "Collectes",
    type: "item",
    url: LINKS.collectes.list,
    caption: "Consulter et gérer les collectes de fonds",
  },
  {
    id: "pre-tri",
    title: "Pré-tri",
    type: "item",
    url: LINKS.pretris.list,
    caption: "Consulter et gérer les pre tris",
  },
  {
    id: "mouvements",
    title: "Mouvements",
    type: "item",
    url: LINKS.mouvements.list,
  },
  {
    id: "arrete-caisse",
    title: "Arrêtés caisses",
    type: "item",
    url: LINKS.arretesCaisses.list,
  },
  {
    id: "coffre-fort",
    title: "Coffres forts clients",
    type: "item",
    url: LINKS.coffresForts.list,
  },
];

export const buildCaisseMenu = (userModule: UserModule) => {
  const data = filterSousMenu(userModule, sousmenus);

  if (data.length) {
    return {
      id: "group-caisse",
      type: "group",
      children: [
        {
          id: "menu-caisse",
          title: "Gestion de caisse",
          type: "collapse",
          icon: CurrencyExchange,
          children: data,
        },
      ],
    };
  }
  return null;
};
